// extracted by mini-css-extract-plugin
export default {"PlainFeature":"vz_a bhk_b"};